module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lee Tobin McClain\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Lee Tobin McClain is the "), _c('I', [_vm._v("New York Times")]), _vm._v(" bestselling author of more than thirty novels. A professor-turned-writer, she finds inspiration in her beautiful and brilliant daughter, her goofy goldendoodle, and her aptly named cat, Trouble. Learn more about her books at www.leetobinmcclain.com.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BZImeq/tc-custom/9781488090370.jpg?1728851686506",
      "alt": "This image is the cover for the book Family for Easter, Rescue River"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Family for Easter, Rescue River\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("With a little help from their matchmaking kids, a single mom and a widowed landscaper find themselves building a forever family in this sweet romance.")]), _c('br'), _c('br'), _vm._v("When wealthy single mom Fiona Farmingham rents her carriage house to widowed Eduardo Delgado, it’s purely a gesture of friendship. Insecure over her late husband’s betrayal, Fiona hides her attraction to the humble landscaper. Between them they have six children, two dogs—and a world of differences. But with half a dozen little matchmakers involved, they may find the courage to reach for happiness once more . . .\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0